// extracted by mini-css-extract-plugin
module.exports = {"contentCardsList":"_3g61k","asCarousel":"_3l4hX"};